import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../const";
import _ from "lodash"
import { Service } from "../../service/service"
import { unAuthorized } from '../../auth/Auth.ducks'
// kids actions

export const FETCH_KIDS_PENDING = "FETCH_KIDS_PENDING";
export const FETCH_KIDS_REJECTED = "FETCH_KIDS_REJECTED";
export const FETCH_KIDS_FULFILLED = "FETCH_KIDS_FULFILLED";

export const FILTER_KIDS_PENDING = "FILTER_KIDS_PENDING";
export const FILTER_KIDS_REJECTED = "FILTER_KIDS_REJECTED";
export const FILTER_KIDS_FULFILLED = "FILTER_KIDS_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case FETCH_KIDS_PENDING:
    case FILTER_KIDS_PENDING:
      return true;
    case FILTER_KIDS_FULFILLED:
    case FETCH_KIDS_FULFILLED:
    case FETCH_KIDS_REJECTED:
    case FILTER_KIDS_REJECTED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case FETCH_KIDS_PENDING:
    case FILTER_KIDS_FULFILLED:
      return null;
    case FETCH_KIDS_REJECTED:
    case FILTER_KIDS_REJECTED:
      return payload;
    default:
      return state;
  }
};

const kids = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_KIDS_FULFILLED:
      { return _.isEmpty(payload.data.enfants) ? null : payload.data.enfants; }

    default:
      return state;
  }
};
const lastArrived = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_KIDS_FULFILLED:
      return _.isEmpty(payload.data.dernierEnfantArrive) ? null : payload.data.dernierEnfantArrive;

    default:
      return state;
  }
};

const filterKids = (state = {}, { type, payload, filter }) => {
  switch (type) {
    case FETCH_KIDS_FULFILLED:
      return _.isEmpty(payload.data.enfants) ? null : payload.data.enfants;
    case FILTER_KIDS_FULFILLED:
      return filter === "TOUS" ? payload : payload.filter(kid => kid.agenda.statutDetails.statut === filter);
    default:
      return state;
  }
};

// kids reducer
export default combineReducers({ loading, error, kids, filterKids, lastArrived });

export const fetchKids = (tok) => {
  return (dispatch) => {
    dispatch({ type: FETCH_KIDS_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: FETCH_KIDS_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: FETCH_KIDS_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};

export const getFilteredKids = (tok, filter) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_KIDS_PENDING })
    const { kids: { list } } = getState();
    let apiEndpoint = `enfant/creche/enfants`;
    if (_.isEmpty(list.kids) || _.isEmpty(filter)) {
      const response = Service.get(`${API}api/${apiEndpoint}`, { headers: { Authorization: `Bearer ${tok}` } })
      response.then((res) => {
        dispatch({ type: FETCH_KIDS_FULFILLED, payload: res })
      })
      response.catch(err => {
        if (filter === "TOUS" || _.isEmpty(filter)) {
          let message = !_.isEmpty(err.response) ? err.response.data.message : null;
          dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
          dispatch({ type: FETCH_KIDS_REJECTED, payload: err })
        }
        if (err.reponse && err.response.status === 401) {
          let message = !_.isEmpty(err.response) ? err.response.data.message : null;
          dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
          dispatch(unAuthorized())
        }
      })
    } else {
      dispatch({ type: FILTER_KIDS_PENDING })
      dispatch({ type: FILTER_KIDS_FULFILLED, payload: list.kids, filter: filter })
    }
  }
};
